
import type { FactoryEntity } from "../../core/entity/EntityType/Factory"
import { Property_Factory1_Factory1_GLTF_Model } from "../gltf_models.generated"
import makePropertyObject3DFactory from "./makePropertyObject3DFactory"

export default makePropertyObject3DFactory<FactoryEntity>(Property_Factory1_Factory1_GLTF_Model)
